interface CheckmarksConnectedByALineSVGProps {
  color: string;
  style: React.CSSProperties;
}

const CheckmarksConnectedByALineSVG = ({
  color,
  style,
}: CheckmarksConnectedByALineSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="42"
    height="50"
    viewBox="0 0 42 50"
    fill="none"
  >
    <path
      d="M34.9585 47.1349C38.7529 45.5525 40.5548 41.1727 38.9831 37.3524C37.4114 33.532 33.0613 31.7178 29.2669 33.3003C25.4725 34.8827 23.6706 39.2625 25.2423 43.0829C26.814 46.9032 31.1641 48.7174 34.9585 47.1349Z"
      stroke={color}
      strokeWidth="1.75"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M29.7866 40.1946L31.6828 41.9049L34.4282 38.5242"
      stroke={color}
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.562 16.6999C17.3565 15.1174 19.1583 10.7376 17.5866 6.91729C16.0149 3.09696 11.6648 1.28278 7.87041 2.86522C4.07599 4.44765 2.27412 8.82746 3.84582 12.6478C5.41752 16.4681 9.76762 18.2823 13.562 16.6999Z"
      stroke={color}
      strokeWidth="1.75"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M8.39014 9.75982L10.2863 11.4701L13.0318 8.08936"
      stroke={color}
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M38.8146 14.8193V22.3762C38.8146 23.5893 37.4912 24.5637 35.8716 24.5637H21.3838"
      stroke={color}
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 38.2357V27.6462C1 25.9459 2.31348 24.5737 3.94299 24.5737H27.2696"
      stroke={color}
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 27.4673V38.0568C1 39.7571 2.31348 41.1293 3.94299 41.1293H21.399"
      stroke={color}
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M38.8148 22.6449V12.0554C38.8148 10.3551 37.5013 8.98291 35.8718 8.98291H22.1543"
      stroke={color}
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CheckmarksConnectedByALineSVG;
